import { Box } from "@mui/material"
import React from "react"
import styles from "./FieldStepper.module.scss"

const FieldsStepper = ({ activeIndex, rows }) => {
  const totalSteps = rows || 4

  return (
    <Box display="flex" gap={3}>
      {totalSteps > 1 &&
        Array.from({ length: totalSteps }).map((_, idx) => (
          <Box
            key={idx}
            className={`${styles.step} ${idx <= activeIndex ? styles.activeStep : ""}`}
          />
        ))}
    </Box>
  )
}

export default FieldsStepper
